interface Options {
  filterUnknowns?: boolean
}

function enumToArray(enumValue: any, opts: Options = {}) {
  return (Object.keys(enumValue).map((i) => enumValue[i]) as string[]).filter((t) => {
    if (opts.filterUnknowns) {
      return !t.endsWith("_UNKNOWN") && !t.startsWith("UNKNOWN_") && t !== "UNRECOGNIZED"
    }
    return true
  })
}

function enumToOptions(enumValue: any, opts: Options = {}) {
  return enumToArray(enumValue, opts).map((value) => ({label: value, value}))
}

export default enumToArray
export {enumToArray, enumToOptions}
